'use client';

import * as React from 'react';
import { useDropzone } from 'react-dropzone';

export interface FileUploadButtonProps {
  onDrop: (files: File[]) => void;
  accept?: { [key: string]: string[] };
  multiple?: boolean;
  buttonText?: string;
  className?: string;
}

export function FileUploadButton({
  onDrop,
  accept,
  multiple = false,
  buttonText = 'Select & Upload Files',
  className = '',
}: FileUploadButtonProps): React.JSX.Element {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
    multiple,
  });

  return (
    <div {...getRootProps()} className={`d-block mx-auto my-3 w-100 cursor-pointer ${className}`}   >
      <input {...getInputProps()} />
      <button type="button" className="btn-continue-outline d-block ">
        {buttonText}
      </button>
    </div>
  );
}
